import { h, FunctionComponent } from 'preact';
import * as styles from '~src/styles/domains/common/components/infoGroup.module.scss';

type InfoGroupProps = {
  header: string;
  value: string | preact.JSX.Element;
};

const InfoGroup: FunctionComponent<InfoGroupProps> = ({ header, value }) => {
  return (
    <div className={styles['info-group']}>
      <div className={styles['info-group-header']}>
        <span>{header}</span>
      </div>
      <div className={styles['info-group-value']}>
        <span>{value}</span>
      </div>
    </div>
  );
};

export default InfoGroup;
